export default {
    common: {

    },
    page: {
        allFormat: 'Celý proces formátovania beží len v prehliadači',
        addCode: 'Vlož JSON',
        formatterStory:{
            one: 'viacúrovňové hierarchické rozdelenie',
            two: 'formátovanie zo stringu',
            three: 'XML formátovanie'
        }
    }
}
